import { ElementRef, Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

declare var $: any;

@Component({
  selector: 'page-business-rich-text-editor',
  templateUrl: 'business-rich-text-editor.html',
})
export class BusinessRichTextEditorPage {

	constructor(
		public elementRef: ElementRef,
		public navCtrl: NavController, 
		public navParams: NavParams) {
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad BusinessRichTextEditorPage');	
	}


	ionViewWillEnter(){
		let $textArea = $(this.elementRef.nativeElement).find(".wysiwyg textarea");

		$textArea.froalaEditor({
			inlineMode: false,
		  	height: 200,
		  	toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough',  
		  					'|', 
		  					'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', 
		  					'|', 
		  					'paragraphFormat',  'align', 'formatOL', 'formatUL', 'outdent', 
		  					'indent', 'quote', '-', 'insertLink', 'insertTable', 
		  					'|', 
		  					'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', 
		  					'|', 
		  					'undo', 'redo']
		});	

		$textArea.on('froalaEditor.contentChanged', (e, editor) => {
	   		// this.form.patchValue(
	   		// 	{"DetailText": editor.html.get()}
	   		// );

			console.log(editor.html.get())
		});				
	}	

}



// WEBPACK FOOTER //
// ./src/pages/business-rich-text-editor/business-rich-text-editor.ts